import React from "react";

export const LegalPage = ({ eyebrow, title, intro, sections }) => (
  <div className="bg-black" data-testid="legal-page">
    <section className="container-kame pt-14 pb-8">
      <p className="eyebrow">{eyebrow}</p>
      <h1 className="font-display text-4xl sm:text-5xl text-white uppercase mt-2">{title}</h1>
      <div className="w-16 h-1 bg-[#B58A50] mt-5" />
      {intro && <p className="text-white/60 mt-5 max-w-2xl">{intro}</p>}
    </section>
    <section className="container-kame pb-20 max-w-3xl space-y-8">
      {sections.map((s, i) => (
        <div key={i}>
          <h2 className="font-display text-xl text-white uppercase mb-3">{s.h}</h2>
          {s.p && <p className="text-white/70 text-sm leading-relaxed">{s.p}</p>}
          {s.list && (
            <ul className="mt-3 space-y-2">
              {s.list.map((li, j) => (
                <li key={j} className="text-white/70 text-sm flex items-start gap-3">
                  <span className="w-1.5 h-1.5 bg-[#B58A50] rounded-full mt-1.5 shrink-0" />
                  {li}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </section>
  </div>
);

export default LegalPage;
